import { Route } from "found";
import React from "react";

import List from "./screens/List";
import Edit from "./screens/Edit";
import Create from "./screens/Create";
import { hasLegacyPerm } from "../utils";

export const routes = (
  <Route path="utilisateurs"
    getData={(data) => {
      if (!hasLegacyPerm(data.context, 'users:list')) data.router.replace("/droits-insuffisant");
    }}
  >
    <Route path="/" Component={List} />
    <Route path="/nouveau" Component={Create} />
    <Route path="/:userId" Component={Edit} />
  </Route>
);
